import isEmpty from 'lodash/isEmpty';
import uuid from 'uuid/v1';


import { assembleBreadcrumbs } from './utils_assemble';




export function buildNewItems(items, position, parentGroup) {
  const { level = -1, id: parentGroupId } = parentGroup || {};
  
  return (items || []).map((data, index) => {
    const { name, image_url, id: itemId } = data;
    const id = uuid();
    const key = itemId;

    return {
      id,
      name,
      key,
      image_url,
      key_level: `${level + 1}::${key}`,
      group: null,
      level: level + 1,
      active: true,
      parent_id: parentGroupId,
      position: position + index,
      is_group: false,
      is_class: false,
      breadcrumbs: assembleBreadcrumbs(id, key, name, parentGroup),
      classification: null,
      is_template_group: true,
      item_id: itemId,
    }
  });
}




export function buildNewGroupClass(data, position, parentGroup) {
  const { level = -1, id: parentGroupId } = parentGroup || {};
  const { name, image_url, list: classId } = data;
  const id = uuid();
  const key = id;

  return {
    id,
    key,
    name,
    position,
    image_url,
    key_level: `${level + 1}::${key}`,
    item: null,
    level: level + 1,
    parent_id: parentGroupId,
    active: true,
    is_class: true,
    is_group: true,
    is_default: true,
    breadcrumbs: assembleBreadcrumbs(id, key, name, parentGroup),
    is_template_group: true,
    group_id: key,
    classification_id: classId,
    parent: parentGroup
  }
}




export function buildNewGroupItem(data, position, parentGroup) {
  const { level = -1, id: parentGroupId } = parentGroup || {};
  const { name, image_url, list } = data;
  const id = uuid();
  const key = id;

  const parent = {
    id,
    key,
    name,
    position,
    image_url,
    key_level: `${level + 1}::${key}`,
    item: null,
    level: level + 1,
    parent_id: parentGroupId,
    active: true,
    is_group: true,
    is_class: false,
    is_default: false,
    hotkey_list: [],
    breadcrumbs: assembleBreadcrumbs(id, key, name, parentGroup),
    classification: null,
    is_template_group: true,
    group_id: id,
    parent: parentGroup
  };

  parent.hotkey_list = buildNewHotkeyList(list, parent);

  return parent;
}




function buildNewHotkeyList(list, parent) {
  if (isEmpty(list)) {
    return [];
  }

  return buildNewItems(list, 0, parent);
}
